import { Box, Checkbox, IconButton, Tooltip, Typography } from "@mui/material";
import {
  CustomActionsContainer,
  CustomContributorsContainer,
  CustomTrackTList,
  CustomVersionsCountContainer,
  DateContainer,
  styles,
} from "../../pages/Tracks/styles";
import {
  CollAndVersionContainer,
  TrackLeftSideContainer,
  TrackNameAndCheckBoxContainer,
  TrackNameAndStatusContainer,
} from "./styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { APP_COLOR } from "../../theme";
import { TracksTableHeadingsProps } from "./types";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export const TracksTableHeadings: React.FC<TracksTableHeadingsProps> = ({
  filterAndSortParams,
  handleAscendingOrDescending,
  isAllTracksSelected,
  setCheckedTracks,
  tracks,
  setIsAllTracksSelected,
}) => {
  return (
    <>
      <CustomTrackTList sx={{ backgroundColor: "#1F242F" }}>
        <TrackLeftSideContainer>
          <TrackNameAndStatusContainer>
            <TrackNameAndCheckBoxContainer>
              <Checkbox
                size="small"
                checked={isAllTracksSelected}
                {...label}
                sx={styles.checkBox}
                onChange={() => {
                  if (isAllTracksSelected) setCheckedTracks([]);
                  else setCheckedTracks(tracks);
                  setIsAllTracksSelected(!isAllTracksSelected);
                }}
              />
              <Tooltip
                title="Name, length, BPM, and genre of your track"
                placement="top"
              >
                <Box sx={styles.trackInformationBox}>
                  Track Information
                  {filterAndSortParams.sortBy === "Title" && (
                    <IconButton onClick={handleAscendingOrDescending}>
                      {filterAndSortParams.isAscending ? (
                        <ArrowUpwardIcon sx={{ color: APP_COLOR }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ color: APP_COLOR }} />
                      )}
                    </IconButton>
                  )}
                </Box>
              </Tooltip>
            </TrackNameAndCheckBoxContainer>
            <Tooltip
              title="Current status of your track in the production process"
              placement="top"
            >
              <Box
                style={{ width: "100px", marginLeft: "12px" }}
                sx={styles.outerNoteContainer}
              >
                Status
              </Box>
            </Tooltip>
          </TrackNameAndStatusContainer>
          <Tooltip
            title="The last date your track version was updated"
            placement="top"
          >
            <DateContainer sx={{ paddingLeft: "68px" }}>
              Updated
              {filterAndSortParams.sortBy === "Last Modified" && (
                <IconButton onClick={handleAscendingOrDescending}>
                  {filterAndSortParams.isAscending ? (
                    <ArrowUpwardIcon sx={{ color: APP_COLOR }} />
                  ) : (
                    <ArrowDownwardIcon sx={{ color: APP_COLOR }} />
                  )}
                </IconButton>
              )}
            </DateContainer>
          </Tooltip>
          <CollAndVersionContainer>
            <Tooltip
              title="The collaborators working with you on your track"
              placement="top"
            >
              <CustomContributorsContainer sx={{ marginLeft: "12px" }}>
                Collaborators
              </CustomContributorsContainer>
            </Tooltip>
            <CustomVersionsCountContainer>
              <Tooltip
                title="The current version of your track. Click the arrow to view all track versions and components. Click the plus sign to add a new version of the track. Select a color-coded status to update the stage of the process the track version is in"
                placement="top"
              >
                <Typography sx={{ marginLeft: -0.7 }}>Version</Typography>
              </Tooltip>
            </CustomVersionsCountContainer>
          </CollAndVersionContainer>
        </TrackLeftSideContainer>
        <Tooltip
          title=" Turn on to share your track publicly to the Explore page for maximum discoverability. Leave off in order to keep the track and its versions private between you and your collaborators"
          placement="top"
        >
          <Box sx={{ width: "60px" }}>Make Public</Box>
        </Tooltip>
        <CustomActionsContainer>
          <Tooltip
            title="Message track collaborators, share tracks with others outside of OmMuse, download tracks, edit information, and manage collaborators"
            placement="top"
          >
            <Box sx={{ minWidth: "70px", marginLeft: 1 }}>Actions</Box>
          </Tooltip>
        </CustomActionsContainer>
      </CustomTrackTList>
    </>
  );
};
